import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageService } from '../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HomeTopUpModel, HomeActiveParkingSession } from '../../../../core/models/user.model';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../core/services/toastNotif.service';
import { PssLoadingComponent } from "../../../../tools/template/pss/pss-loading/pss-loading.component";
import { PssSuccessComponent } from "../../../../tools/template/pss/pss-success/pss-success.component";
import { PageListService } from '../../../../core/services/page-list.service';
import { Providers } from '../../../../core/models/information.model';
import { ToastCustomService } from '../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiTopUpService } from '../../../../core/services/api/Topup/api-topup';
import { ApiProviderService } from '../../../../core/services/api/Parking/api-provider';
import { ApiNewsService } from '../../../../core/services/api/News/api-news';
import { ApiSitePublicService } from '../../../../core/services/api/SitePublic/api-site-public';
import { LiffHomeMenuStateService } from '../../../../core/services/liff-home-menu-state.service';
import { PublicNewsListItem } from '../../../../core/models/news.model';
import { HomeParkingSiteCard } from '../../../../core/models/site-public-profile.model';
import { SiteAmenitiesComponent } from '../../../../shared/components/site-amenities/site-amenities.component';

@Component({
  selector: 'app-home-2',
  imports: [CommonModule, PssLoadingComponent, PssSuccessComponent, SiteAmenitiesComponent],
  templateUrl: './home-2.component.html',
  styleUrl: './home-2.component.css',
})
export class Home2Component implements OnInit, OnDestroy {
  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;

  /* --- AD --- */
  adImages: { image: string, name: string, adType: string, siteId: number }[] = [
    {
      image: '/images/Advert/cover photo site parking-01.png',
      name: 'The Market',
      adType: 'register-member',
      siteId: 1
    },
    {
      image: '/images/Advert/cover photo site parking-02.png',
      name: 'ArounD Lifestyle Station',
      adType: 'register-member',
      siteId: 4
    },
    {
      image: '/images/Advert/AdvertEvCharger.png',
      name: 'EV Charger',
      adType: 'ev-charger',
      siteId: 0
    },
  ];
  ProvidersOptions: {
    id: number;
    name: string;
    address: string;
    logo_base64: string;
  }[] = [];

  quickServiceList: any[] = [];
  moreMenuCategories: any[] = [];

  /* ---- Active parking sessions (multi-vehicle) ---- */
  activeSessions: HomeActiveParkingSession[] = [];

  /* ---- แสดงแจ้งเตือน ----*/
  homeTopUpData: HomeTopUpModel = {
    vehicleCount: 0,
    evCount: 0,
    amount: 0,
    activateCard: 0,
    notify: 0
  };

  displayName: string = '';
  pictureUrl: string = '';
  isMoreSheetOpen: boolean = false;

  currentIndex = 0;
  intervalId: any;
  token: string = '';
  uid: string = '';

  // PSS
  isLoading: boolean = false;
  homeNews: PublicNewsListItem[] = [];
  isNewsLoading: boolean = false;
  homeParkingSites: HomeParkingSiteCard[] = [];
  isSitesLoading: boolean = false;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''

  constructor(
    private languageService: LanguageService,
    private router: Router,
    private cookieService: CookieService,
    private apiTopUpService: ApiTopUpService,
    private apiProviderService: ApiProviderService,
    private apiNewsService: ApiNewsService,
    private apiSitePublicService: ApiSitePublicService,
    private liffHomeMenuState: LiffHomeMenuStateService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private page: PageListService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT อยู่ใน HttpOnly cookie — ไม่มี token_user ใน JS อีกแล้ว
    this.token = '';

    // โหลดข้อมูล Line profile จาก cookie / localStorage
    this.displayName = this.cookieService.get('display_name') || localStorage.getItem('display_name') || 'คุณ ณัฐพล อัศวาภิรมย์';
    const rawPic = this.cookieService.get('picture_url') || localStorage.getItem('picture_url') || '';
    this.pictureUrl = (rawPic && rawPic !== 'null' && rawPic !== 'undefined') ? rawPic : '';

    // โชว์ Modal Success;
    const navigation = this.router.getCurrentNavigation();
    if (navigation) {
      const state = navigation?.extras?.state;
      this.isSuccess = state?.['isSuccess'].result ?? null;
      this.textSuccess = state?.['isSuccess'].text ?? null;
      this.detailSuccess = state?.['isSuccess'].details ?? null;
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.sub?.unsubscribe();
  }

  ngOnInit() {
    this.startAutoSlide();
    this.getHomeTopUp();
    this.requestGetProviders();
    this.loadHomeParkingSites();
    this.loadHomeNews();
    this.loadLiffHomeMenus();
  }

  // ================= Normal Functions =================

  /**
   * สลับภาษาของระบบ (TH <=> EN)
   * @param lang รหัสภาษาที่เลือก
   */
  changeLang(lang: 'TH' | 'EN') {
    if (this.currentLang !== lang) {
      this.languageService.switchLang();
    }
  }

  /**
   * แสดงข้อความแจ้งเตือนประเภทแจ้งเตือน (Warning)
   */
  showWarning(text: string, detail: string = '') {
    this.toastCustomService.showWarning('', text);
  }

  /**
   * แสดงข้อความแจ้งเตือนประเภทข้อผิดพลาด (Error)
   */
  showError(text: string, detail: string = '') {
    this.toastCustomService.showError('', text);
  }

  /**
   * แสดงข้อความแจ้งเตือนประเภทสำเร็จ (Success)
   */
  showSuccess(text: string, detail: string = '') {
    this.toastCustomService.showSuccess('', text);
  }

  /**
   * นำทางไปยังลิงก์ปลายทางตามประเภทโฆษณา (AD)
   */
  goToADImage(ADtype: string, siteId: number) {
    if (ADtype === 'register-member') {
      this.goRegisterMember(siteId);
    } else if (ADtype === 'ev-charger') {
      this.goToNavigate('/ev-charger');
    }
  }

  /**
   * นำทางไปยังหน้าลงทะเบียนผู้ให้บริการที่เลือก
   */
  goRegisterMember(siteId: number) {
    const provider = this.ProvidersOptions.find((provider) => provider.id === siteId);
    if (!provider) return;

    setTimeout(() => {
      sessionStorage.setItem('providerId', provider.id.toString());
      sessionStorage.setItem('providerName', provider.name);
      this.router.navigate(['/register-member-vehicle'], {
        state: { providerId: provider.id },
      });
    }, 0);
  }

  /**
   * นำทางไปยัง URL ที่กำหนด
   */
  goToNavigate(url: string) {
    this.router.navigate([url]);
  }

  /**
   * จัดการแตะไอคอน Quick Service — More เปิด sheet, อื่นๆ นำทาง
   */
  onQuickServiceTap(data: any) {
    if (data.disable) return;
    if (data.action === 'more' || data.route === 'more') {
      this.openMoreSheet();
      return;
    }
    this.goToNavigate('/' + data.route);
  }

  /** EV quick tile — วงไอคอนเหลืองตาม mock */
  isEvQuick(data: any): boolean {
    const route = String(data?.route || '').toLowerCase();
    const alt = String(data?.alt || '').toLowerCase();
    return route === 'ev-charger' || alt.includes('ev');
  }

  /**
   * เปิด bottom sheet เมนูทั้งหมด
   */
  openMoreSheet() {
    this.isMoreSheetOpen = true;
  }

  /**
   * ปิด bottom sheet เมนูทั้งหมด
   */
  closeMoreSheet() {
    this.isMoreSheetOpen = false;
  }

  /**
   * นำทางจาก More sheet แล้วปิด sheet
   */
  onMoreMenuTap(data: any) {
    if (data.disable) return;
    this.closeMoreSheet();
    this.goToNavigate('/' + data.route);
  }

  /**
   * แปลงนาทีเป็นชั่วโมง (สำหรับแสดงระยะเวลาจอด)
   */
  hour(totalTime: number): number {
    return Math.floor((totalTime || 0) / 60);
  }

  /**
   * นำทางไปหน้ารายการรถกำลังจอด
   */
  goToActiveParking() {
    this.goToNavigate('/check-amount-parking');
  }

  /**
   * เริ่มการสไลด์รูปภาพโฆษณาโดยอัตโนมัติ
   */
  startAutoSlide() {
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.adImages.length;
    }, 5000);
  }

  /**
   * นำทางไปยังสไลด์รูปโฆษณาที่ต้องการ
   */
  goToSlide(index: number) {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.startAutoSlide();
    }
    this.currentIndex = index;
  }

  /**
   * ใช้ระบุความเฉพาะเจาะจงของรายการเมนูเพื่อลดการเรนเดอร์ซ้ำ
   */
  trackById(_: number, item: any) {
    return item.route;
  }

  /**
   * track session card by plate + site
   */
  trackBySession(_: number, item: HomeActiveParkingSession) {
    return `${item.entryLicense}-${item.siteId}-${item.seq}`;
  }

  /**
   * site จาก session (providerId) — ว่าง = โชว์เฉพาะ Global
   */
  newsTitle(item: PublicNewsListItem): string {
    if (this.currentLang === 'EN' && item.titleEn?.trim()) return item.titleEn;
    return item.title;
  }

  goToNewsList(): void {
    this.router.navigate(['/news']);
  }

  goToNewsDetail(id: number): void {
    this.router.navigate(['/news-detail', id]);
  }

  siteTitle(site: HomeParkingSiteCard): string {
    if (this.currentLang === 'EN' && site.titleEn?.trim()) return site.titleEn;
    return site.titleTh;
  }

  siteSummary(site: HomeParkingSiteCard): string {
    if (this.currentLang === 'EN' && site.summaryEn?.trim()) return site.summaryEn;
    return site.summaryTh || '';
  }

  trackBySite(_: number, item: HomeParkingSiteCard): string {
    return item.publicRef;
  }

  goToParkingSiteDetail(site: HomeParkingSiteCard | string): void {
    const ref =
      typeof site === 'string'
        ? (site || '').trim()
        : String(site?.publicRef || '').trim();
    if (!ref) {
      console.warn('goToParkingSiteDetail: missing publicRef', site);
      this.showWarning(
        this.currentLang === 'TH'
          ? 'ไม่สามารถเปิดรายละเอียดลานได้'
          : 'Unable to open parking site',
      );
      return;
    }
    void this.router.navigate(['/lot', ref]);
  }

  /**
   * คืนค่า badge จำนวนแจ้งเตือนตามประเภท alert ของเมนู
   */
  alertCount(alertKey: string): number {
    if (alertKey === 'vehicleCount') return this.homeTopUpData.vehicleCount || 0;
    if (alertKey === 'evCount') return this.homeTopUpData.evCount || 0;
    if (alertKey === 'activateCard') return this.homeTopUpData.activateCard || 0;
    return 0;
  }

  /**
   * แปลง ActiveSessions จาก GetHomeInfo (รองรับทั้ง camelCase / PascalCase)
   */
  mapActiveSessions(raw: any[]): HomeActiveParkingSession[] {
    return (raw || []).map((s) => ({
      seq: s.seq ?? s.Seq ?? 0,
      entryLicense: s.entryLicense ?? s.EntryLicense ?? '',
      entryDate: s.entryDate ?? s.EntryDate ?? null,
      entryGateName: s.entryGateName ?? s.EntryGateName ?? '',
      siteId: s.siteId ?? s.SiteId ?? 0,
      siteName: s.siteName ?? s.SiteName ?? '',
      totalTime: s.totalTime ?? s.TotalTime ?? 0,
      totalPay: s.totalPay ?? s.TotalPay ?? null,
      isFeeReady: !!(s.isFeeReady ?? s.IsFeeReady),
      provinceName: s.provinceName ?? s.ProvinceName ?? '',
      logo: s.logo ?? s.Logo ?? '',
      providerId: s.providerId ?? s.ProviderId ?? 0,
      entranceUuid: s.entranceUuid ?? s.EntranceUuid ?? '',
    }));
  }

  /**
   * ดึงราคาจอดตามหลัง (Taiwan) แล้วอัปเดตการ์ด — ระหว่างรอโชว์ blur
   */
  loadHomeParkingFees() {
    if (!this.uid || this.activeSessions.length === 0) return;

    this.apiTopUpService.getHomeParkingFees(this.uid).subscribe({
      next: (fees) => {
        const list = fees || [];
        const bySeq = new Map(
          list.map((f: any) => [
            f.seq ?? f.Seq,
            {
              totalPay: f.totalPay ?? f.TotalPay ?? 0,
              totalTime: f.totalTime ?? f.TotalTime,
              isFeeReady: !!(f.isFeeReady ?? f.IsFeeReady ?? true),
            },
          ]),
        );
        this.activeSessions = this.activeSessions.map((s) => {
          const fee = bySeq.get(s.seq);
          if (!fee) return s;
          return {
            ...s,
            totalPay: fee.totalPay,
            totalTime: fee.totalTime ?? s.totalTime,
            isFeeReady: fee.isFeeReady,
          };
        });
      },
      error: (err) => {
        console.error('GetHomeParkingFees failed', err);
        // keep cards visible; leave fee blurred / not ready
      },
    });
  }

  // ================= API Functions =================

  /**
   * ดึงข้อมูลหน้าหลัก: ยอด EV + ActiveSessions (DB เร็ว) จาก GetHomeInfo
   * จากนั้นโหลดราคาจอดแบบ async ผ่าน GetHomeParkingFees
   */
  getHomeTopUp() {
    this.isLoading = true;
    if (!this.uid) {
      this.isLoading = false;
      this.showWarning(
        this.currentLang === 'TH'
          ? 'ไม่พบ LINE uid กรุณาเข้าใหม่ผ่าน /register'
          : 'Missing LINE uid. Please re-enter via /register.',
      );
      return;
    }

    this.apiTopUpService.getHomeTopUp(this.uid, this.token).subscribe({
      next: (response: HomeTopUpModel) => {
        console.log('response data Home Top Up : ', response);
        this.isLoading = false;
        this.homeTopUpData = response;
        const rawSessions =
          response.activeSessions ||
          (response as any).ActiveSessions ||
          [];
        this.activeSessions = this.mapActiveSessions(rawSessions);
        sessionStorage.setItem('homeTopUp', JSON.stringify(response));

        const needsFee = this.activeSessions.some((s) => !s.isFeeReady);
        if (needsFee) {
          this.loadHomeParkingFees();
        }
      },
      error: (err) => {
        console.error('โหลดข้อมูล Home Top Up ล้มเหลว', err);
        this.isLoading = false;
        this.activeSessions = [];
      },
    });
  }

  /**
   * ดึงข้อมูลรายชื่อผู้ให้บริการจอดรถทั้งหมด
   */
  requestGetProviders() {
    this.isLoading = true;
    this.apiProviderService.getProviders().subscribe({
      next: (response: Providers[]) => {
        this.isLoading = false;

        this.ProvidersOptions = response.map(
          (provider: Providers) => ({
            id: provider.id,
            name: provider.name,
            address: provider.address,
            logo_base64: provider.logo_base64,
          })
        );
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  /**
   * ลานจอดแนะนำบน Home (online + published)
   */
  loadHomeParkingSites(): void {
    this.isSitesLoading = true;
    this.apiSitePublicService.getHomeParkingSites().subscribe({
      next: (res) => {
        this.homeParkingSites = (res || []).filter((s) => !!s.publicRef);
        this.isSitesLoading = false;
      },
      error: (err) => {
        console.error('getHomeParkingSites failed', err);
        this.homeParkingSites = [];
        this.isSitesLoading = false;
      },
    });
  }

  /**
   * ดึงข่าว public สำหรับบล็อก Home (สูงสุด 5)
   */
  loadHomeNews(): void {
    this.isNewsLoading = true;
    this.apiNewsService.getPublicNewsForHome(null, 5).subscribe({
      next: (res) => {
        this.homeNews = res || [];
        this.isNewsLoading = false;
      },
      error: (err) => {
        console.error('getPublicNewsForHome failed', err);
        this.homeNews = [];
        this.isNewsLoading = false;
      },
    });
  }

  /**
   * โหลดเมนู Quick + More — session cache (เรียก API ครั้งเดียวต่อรอบเปิดแอป)
   */
  loadLiffHomeMenus(): void {
    const snap = this.liffHomeMenuState.snapshot;
    if (snap) {
      this.quickServiceList = snap.quick;
      this.moreMenuCategories = snap.more;
      return;
    }

    // แสดง static ชั่วคราวระหว่างรอครั้งแรกของ session
    this.quickServiceList = [...(this.page.quickServiceList || [])];
    this.moreMenuCategories = (this.page.commonList || [])
      .filter((c: any) => c.categoryEN !== 'Home')
      .map((c: any) => ({
        ...c,
        list: [...(c.list || [])],
      }));

    this.liffHomeMenuState.getMenus().subscribe({
      next: (menus) => {
        this.quickServiceList = menus.quick;
        this.moreMenuCategories = menus.more;
      },
    });
  }
}
